export const FLASHYPLAYER_LATEST_VERSION = '0.6';

export const CONTACT_EMAIL = 'info@flashyplayer.com';

export const FLASHY_PLAYER_BLUE = '#2196F3';

export const flashyplayerSetup64Url = `downloads/flashyplayer-setup-x64-${FLASHYPLAYER_LATEST_VERSION}.exe`;
export const flashyplayerSetup86Url = `downloads/flashyplayer-setup-x86-${FLASHYPLAYER_LATEST_VERSION}.exe`;
